import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: theme.typography.pxToRem(40),
    height: theme.typography.pxToRem(40),
    '& :hover': {
      cursor: 'pointer',
    },
  },

  photoContainer: {
    width: '100%',
    height: '100%',
    '& img': {
      maxWidth: '100%',
      height: '100%',
      borderRadius: theme.typography.pxToRem(4),
    },
  },

  placeholderIcon: {
    // width: '100%',
    // height: '100%',
  },
}));

export default useStyles;
